export default __webpack_public_path__ + "static/media/image19.ce07c0ff.jpeg";